export default "__VITE_ASSET__D9M7RBIx__ 100w";